import { getRecoil } from '../state/recoilNexus'
import { sessionAtom } from '../state/session'

export const isSelectedStream = (stream: string) => {
	return getRecoil(sessionAtom)?.selectedBusinessStream === stream
}
